export enum HydrationStateEnum {
  customer = 'customer',
  cart = 'cart',
}
